export const literature = [
  {
    questionText: "What word rhymes with CAT?",
    answerOptions: [
      { answerText: "Dog", isCorrect: false },
      { answerText: "Mouse", isCorrect: false },
      { answerText: "Hat", isCorrect: true },
      { answerText: "Milk", isCorrect: false },
    ],
  },
  {
    questionText: "What word rhymes with Dog?",
    answerOptions: [
      { answerText: "Bone", isCorrect: false },
      { answerText: "Frog", isCorrect: true },
      { answerText: "Tail", isCorrect: false },
      { answerText: "Food", isCorrect: false },
    ],
  },
  {
    questionText: "What word rhymes with Play?",
    answerOptions: [
      { answerText: "May", isCorrect: true },
      { answerText: "July", isCorrect: false },
      { answerText: "School", isCorrect: false },
      { answerText: "Toy", isCorrect: false },
    ],
  },
  {
    questionText: "What word rhymes with Green?",
    answerOptions: [
      { answerText: "Grapes", isCorrect: false },
      { answerText: "Princess", isCorrect: false },
      { answerText: "King", isCorrect: false },
      { answerText: "Queen", isCorrect: true },
    ],
  },
  {
    questionText: "What word rhymes with Blue?",
    answerOptions: [
      { answerText: "Sky", isCorrect: false },
      { answerText: "Pants", isCorrect: false },
      { answerText: "Shoe", isCorrect: true },
      { answerText: "Socks", isCorrect: false },
    ],
  },
  {
    questionText: "What word rhymes with Cake?",
    answerOptions: [
      { answerText: "Shake", isCorrect: true },
      { answerText: "Juice", isCorrect: false },
      { answerText: "Chocolate", isCorrect: false },
      { answerText: "Eat", isCorrect: false },
    ],
  },
  {
    questionText: "What word rhymes with House?",
    answerOptions: [
      { answerText: "Chair", isCorrect: false },
      { answerText: "Street", isCorrect: false },
      { answerText: "Bedroom", isCorrect: false },
      { answerText: "Mouse", isCorrect: true },
    ],
  },
  {
    questionText: "Who built a house of straw in the Three Little Pigs?",
    answerOptions: [
      { answerText: "The wolf", isCorrect: false },
      { answerText: "The first pig", isCorrect: true },
      { answerText: "The farmer", isCorrect: false },
      { answerText: "The grandma", isCorrect: false },
    ],
  },
  {
    questionText: "What did the tortoise use to beat the hare in the race?",
    answerOptions: [
      { answerText: "His strength", isCorrect: false },
      { answerText: "His cunning", isCorrect: false },
      { answerText: "His slowness", isCorrect: false },
      { answerText: "His perseverance", isCorrect: true },
    ],
  },
  {
    questionText: "What did Cinderella leave behind at the ball?",
    answerOptions: [
      { answerText: "Her shoe", isCorrect: true },
      { answerText: "Her dress", isCorrect: false },
      { answerText: "Her pumpkin", isCorrect: false },
      { answerText: "Her mask", isCorrect: false },
    ],
  },
  {
    questionText: 'Who cried "Wolf!" too many times?',
    answerOptions: [
      { answerText: "The sheep", isCorrect: false },
      { answerText: "The hunter", isCorrect: false },
      { answerText: "The little boy", isCorrect: true },
      { answerText: "The grandma", isCorrect: false },
    ],
  },

  {
    questionText: "What is the house made of in the Three Little Pigs Story?",
    answerOptions: [
      { answerText: "Straw, Wood and Bricks", isCorrect: true },
      { answerText: "Candy, Chocolate and Cookies", isCorrect: false },
      { answerText: "Wood, Sand and Concrete", isCorrect: false },
      { answerText: "Construction Material", isCorrect: false },
    ],
  },
  {
    questionText: "What lesson does a fable usually teach?",
    answerOptions: [
      { answerText: "A funny story", isCorrect: false },
      { answerText: "A scary story", isCorrect: false },
      { answerText: "A lesson to learn", isCorrect: true },
      { answerText: "A long poem", isCorrect: false },
    ],
  },
  {
    questionText: "What are colorful pictures with a story called?",
    answerOptions: [
      { answerText: "Books", isCorrect: false },
      { answerText: "Comics", isCorrect: true },
      { answerText: "Fables", isCorrect: false },
      { answerText: "Songs", isCorrect: false },
    ],
  },
  {
    questionText: "What is the main character in a story called?",
    answerOptions: [
      { answerText: "The monster", isCorrect: false },
      { answerText: "The hero", isCorrect: true },
      { answerText: "The ending", isCorrect: false },
      { answerText: "The title", isCorrect: false },
    ],
  },
  {
    questionText: "What happens at the end of a story?",
    answerOptions: [
      { answerText: "The beginning", isCorrect: false },
      { answerText: "The middle", isCorrect: false },
      { answerText: "The ending", isCorrect: true },
      { answerText: "The pictures", isCorrect: false },
    ],
  },
  {
    questionText:
      "Cinderella's fairy godmother turned a __________ into a carriage.",
    answerOptions: [
      { answerText: "An Apple", isCorrect: false },
      { answerText: "A Pumpkin", isCorrect: true },
      { answerText: "A Pear", isCorrect: false },
      { answerText: "A Watermelon", isCorrect: false },
    ],
  },
  {
    questionText: "Snow White received one poisoned fruit. Which fruit was it?",
    answerOptions: [
      { answerText: "A Pumpkin", isCorrect: false },
      { answerText: "A Pear", isCorrect: false },
      { answerText: "An Apple", isCorrect: true },
      { answerText: "A Watermelon", isCorrect: false },
    ],
  },
  {
    questionText: "What did Little Red Riding Hood bring to her grandma?",
    answerOptions: [
      { answerText: "A Bunch of Flowers", isCorrect: false },
      { answerText: "A Basket of food", isCorrect: true },
      { answerText: "A New Dress", isCorrect: false },
      { answerText: "A Wolf", isCorrect: false },
    ],
  },
  {
    questionText:
      "What magical words did Cinderella's fairy Godmother use to make her pumpkin carriage appear?",
    answerOptions: [
      { answerText: "Abracadabra", isCorrect: false },
      { answerText: "Levioooosa", isCorrect: false },
      { answerText: "Bibbidi-Bobbidi-Boo", isCorrect: true },
      { answerText: "Open Sesame", isCorrect: false },
    ],
  },
  {
    questionText: "Who wished for three wishes from a genie?",
    answerOptions: [
      { answerText: "Jack and the Beanstalk", isCorrect: false },
      { answerText: "The Three Musketeers", isCorrect: false },
      { answerText: "Sleeping Beauty", isCorrect: false },
      { answerText: "Aladdin", isCorrect: true },
    ],
  },
  {
    questionText: "What color is Snow White's hair?",
    answerOptions: [
      { answerText: "White", isCorrect: false },
      { answerText: "Blond", isCorrect: false },
      { answerText: "Red", isCorrect: false },
      { answerText: "Black", isCorrect: true },
    ],
  },
  {
    questionText: "What magical power does Elsa from Frozen have?",
    answerOptions: [
      { answerText: "Making ice and snow", isCorrect: true },
      { answerText: "Talking to animals", isCorrect: false },
      { answerText: "Super strength", isCorrect: false },
      { answerText: "Flying", isCorrect: false },
    ],
  },
  {
    questionText:
      "In Frozen, Olaf the snowman dreams of one thing. What is it?",
    answerOptions: [
      { answerText: "Summer", isCorrect: true },
      { answerText: "Winter", isCorrect: false },
      { answerText: "A hug", isCorrect: false },
      { answerText: "Making friends", isCorrect: false },
    ],
  },
];
